'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;
exports.setRedirectedPath = setRedirectedPath;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SET_REDIRECTED_PATH = 'redux-frontend/redirect/SET_REDIRECTED_PATH';

var initialState = {
  path: '',
  code: 301
};

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case SET_REDIRECTED_PATH:
      return (0, _extends3.default)({}, state, {
        path: action.path
      });
    default:
      return state;
  }
}

function setRedirectedPath(path) {
  var code = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 301;

  return {
    type: SET_REDIRECTED_PATH,
    path: path,
    code: code
  };
}


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/redirect.js
// module id = 326
// module chunks = 47